import { useMutation } from 'react-query';
import { RegisterRequest } from '@solin-fitness/types';
import { fetchRegister } from 'queries/auth';

export default () => {
  return useMutation(({ data }: { data: RegisterRequest }) =>
    fetchRegister(data),
  );
};
